// page src/hooks/usePayment.ts
import { useState } from "react";

import {
  subscriptionService,
} from "../services/subscriptionService";

import type {
  PaymentResponse,
} from "../types/payment";

export const usePayment = () => {

  const [loading, setLoading] =
    useState(false);

  const startSubscriptionCheckout =
    async (
      userId: string,
      planId: string,
      planTypeId?: number,
      couponCode?: string
    ): Promise<PaymentResponse> => {

      try {

        setLoading(true);

        return await (
          subscriptionService.checkout(
            userId,
            planId,
            planTypeId,
            couponCode
          )
        );

      } finally {

        setLoading(false);

      }

    };

  return {
    loading,
    startSubscriptionCheckout,
  };

};